import { render, staticRenderFns } from "./ProgressBiaya.vue?vue&type=template&id=73b46873&"
import script from "./ProgressBiaya.vue?vue&type=script&lang=js&"
export * from "./ProgressBiaya.vue?vue&type=script&lang=js&"
import style0 from "./ProgressBiaya.vue?vue&type=style&index=0&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports